
/*eslint-disable*/
import React from "react";

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

class Calendar extends React.Component {
  render() {
    return (
      <>
        <Container fluid className={"main-footer-side"}>
          <footer className="footer pt-0">
            <Row className="align-items-center justify-content-lg-between">
              <Col lg="12">
                <div className="copyright text-right text-muted">
                  © {new Date().getFullYear()}{" "}
                  <a
                    className="font-weight-bold ml-1"
                    href="/"
                    target="_blank"
                  >
                    TheXApp
                  </a>
                </div>
              </Col>
              
            </Row>
          </footer>
        </Container>
      </>
    );
  }
}

export default Calendar;
